import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { MaterialAmountEntity } from '../../entities/material-amount.entity';
import { getLatestUpdatedAt } from '../../helper/reducer.helper';
import { MaterialAmountActionTypes } from '../actions/material-amount.actions';

export const MATERIAL_AMOUNT_KEY = 'materialAmount';

export interface MaterialAmountState extends EntityState<MaterialAmountEntity> {
    fetched: boolean;
    latestUpdatedAt: Date;
}

const adapter = createEntityAdapter<MaterialAmountEntity>({
    selectId: (Entity) => Entity.GetId(),
});

const initialState = adapter.getInitialState({
    fetched: false,
    latestUpdatedAt: null,
});

export const materialAmountReducer = createReducer(
    initialState,
    on(MaterialAmountActionTypes.UpdateAll, (state, { Payload, updateLatestUpdatedAt }) =>
        adapter.setAll(Payload, {
            ...state,
            fetched: true,
            latestUpdatedAt: updateLatestUpdatedAt
                ? getLatestUpdatedAt(
                      Payload.map((e) => ({ UpdatedAt: e.CreatedAt })),
                      state.latestUpdatedAt,
                  )
                : state.latestUpdatedAt,
        }),
    ),
    on(MaterialAmountActionTypes.UpdateMany, (state, { Payload, updateLatestUpdatedAt }) =>
        adapter.setMany(Payload, {
            ...state,
            latestUpdatedAt: updateLatestUpdatedAt
                ? getLatestUpdatedAt(
                      Payload.map((e) => ({ UpdatedAt: e.CreatedAt })),
                      state.latestUpdatedAt,
                  )
                : state.latestUpdatedAt,
        }),
    ),
);

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllMaterialAmounts = selectAll;
export const selectMaterialAmountEntities = selectEntities;

export const selectMaterialAmountFetched = (state: MaterialAmountState) => state.fetched;
export const selectMaterialAmountLatestUpdatedAt = (state: MaterialAmountState) => state.latestUpdatedAt;
